import type { VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { VERCEL_CLI_VERSION } from '@cli-constants/tool-versions.js'

export function npxRunner(): VercelRunner {
  return { bin: 'npx', prefix: ['-y', `vercel@${VERCEL_CLI_VERSION}`], source: 'npx' }
}
